import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import {
	buildBoundingBox,
	buildElementInfo,
	MOBILE_SEVERITY_MAP
} from 'src/common/helpers/MobileQueriesHelper';
import { MobileA11yGuideline, MobileIssueDetails } from 'src/common/types/MobileSingleSessionTypes';

import { MobileSdkIssueDetailsQuery } from '../MobileSdkIssueDetails.generated';

const transformIssueToMobileIssueDetails = (
	issue: NonNullable<NonNullable<MobileSdkIssueDetailsQuery['issues']>[0]>
): MobileIssueDetails => {
	const elementInfo = buildElementInfo(issue);
	const boundingBox = buildBoundingBox(issue);

	// Parse a11y guidelines from tags if available
	const a11yGuidelines: MobileA11yGuideline[] = [];
	issue.tags__description?.forEach((item, index) => {
		const title = item.trim();
		const link = issue.tags__link?.[index].trim();

		if (title && link) {
			a11yGuidelines.push({ title, link });
		}
	});

	return {
		type: issue.type_name,
		description: issue.description,
		severity: MOBILE_SEVERITY_MAP[issue.severity_name],
		signature: issue.signature,
		scanName: issue.scan_name,
		elementIndex: issue.elements__index?.[0] ?? '',
		scanDate: issue.run_time ?? '',
		screenshotDetails: {
			pageScreenshotUrl: issue.screenshot,
			boundingBox,
			viewportWidth: issue.viewport_width,
			viewportHeight: issue.viewport_height
		},
		taskManagerTickets: [],
		elementInfo,
		knowledgeBaseLink: issue.knowledge_base_link,
		expectations: [], // replace when schema will support issue expectations
		a11yGuidelines
	};
};

export const transformMobileSdkIssueDetailsResults = (
	result: MobileSdkIssueDetailsQuery
): MobileIssueDetails | null => {
	const issues = result.issues?.filter(returnNonNull);

	if (!issues?.length) {
		return null;
	}

	return transformIssueToMobileIssueDetails(issues[0]);
};
